import { Injectable } from '@angular/core';
import { filter, Observable, Subject } from 'rxjs';

export interface AppEvent<T = unknown> {
  type: string;
  payload?: T;
}

@Injectable({ providedIn: 'root' })
export class EventService {
  private _event = new Subject<AppEvent>();

  emit<T>(type: string, payload?: T): void {
    this._event.next({ type, payload });
  }

  on<T>(type: string): Observable<AppEvent<T>> {
    return this._event.asObservable().pipe(
      filter(event => event.type === type)
    ) as Observable<AppEvent<T>>;
  }
}
